/**
 * Filter events by data from FilterBy
 *
 * @param {array} events
 * @param {object} data from FilterBy
 */
export default function (eventsToFilter, setting) {
  const {
    teacher: teacherForFiltering,
    classroom: classroomForFiltering,
    class: classForFiltering,
  } = setting;


  return eventsToFilter.filter((evt)=>{
    let toInclude = true;

    if (teacherForFiltering && teacherForFiltering.IDs.length > 0) {
      let found = _.find(evt.teacher_list, (teacher)=>{
        return teacherForFiltering.IDs.indexOf(teacher.id) > -1;
      });

      if (!found) {
        return false;
      }
    }

    if (classForFiltering && classForFiltering.IDs.length > 0) {
      if (classForFiltering.IDs.indexOf(evt.lClass) === -1) {
        return false;
      }
    }

    if (classroomForFiltering && classroomForFiltering.IDs.length > 0) {
      if (classroomForFiltering.IDs.indexOf(evt.lClassroom) === -1) {
        return false;
      }
    }

    return toInclude;
  });

}



// WEBPACK FOOTER //
// ./src/shared/ScheduleDisplayer/filterEvents.js